import { createStore, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
// import { createLogger } from 'redux-logger';
import reducers from './reducers';

// const loggerMiddleware = createLogger();
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function (preloadedState) {
  return createStore(
    reducers,
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        thunkMiddleware
      ))
  )
}


// WEBPACK FOOTER //
// ./src/store/index.js